<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
    <path d="M7 0.75C10.3761 0.750211 13.0263 3.28737 13.0264 6.28906C13.0264 7.94913 12.2686 8.70113 11.2871 9.77246C10.7981 10.3062 10.2521 10.9268 9.83887 11.752C9.4199 12.5886 9.15434 13.5992 9.1543 14.9141C9.1543 14.935 9.14649 14.9664 9.11035 15C9.07329 15.0344 9.0126 15.0625 8.93555 15.0625H5.06348C4.9867 15.0625 4.92674 15.0342 4.88965 15C4.85346 14.9664 4.84473 14.935 4.84473 14.9141C4.84469 13.5907 4.57962 12.5772 4.16016 11.7402C3.7463 10.9145 3.19924 10.2973 2.70996 9.76758C1.73014 8.70678 0.972656 7.96383 0.972656 6.28906C0.97273 3.28724 3.62373 0.75 7 0.75Z" stroke="#1B294A" stroke-width="1.5" stroke-linejoin="round"/>
    <path d="M5.38574 17.2188H8.61328C8.63785 17.2188 8.65382 17.2272 8.66309 17.2344C8.65384 17.2416 8.63796 17.2499 8.61328 17.25H5.38574C5.36106 17.25 5.34522 17.2416 5.33594 17.2344C5.34524 17.2272 5.36117 17.2188 5.38574 17.2188Z" stroke="#1B294A" stroke-width="1.5"/>
    <path d="M6.99989 11.5412V8.15273M6.99989 8.15273L8.69413 6.4585M6.99989 8.15273L5.30566 6.4585" stroke="#1B294A" stroke-width="1.5" stroke-linecap="round"/>
  </svg>
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  name: 'IconLamp'
}
</script>
